document.addEventListener("DOMContentLoaded", function(){

    var swiperingredients = new Swiper(".ingredients__side--inner", {
        slidesPerView: 1,
        spaceBetween: 0,
        scrollbar: {
          el: ".swiper-scrollbar.ingredients",
           draggable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next.ingredients",
          prevEl: ".swiper-button-prev.ingredients",
        },
      });
      });